import { create } from 'zustand';

type PanelType = 'none' | 'spaceSelection' | 'textManipulation';

interface SpaceToolsState {
  activePanel: PanelType;
  menuOpen: boolean;
  setActivePanel: (panel: PanelType) => void;
  togglePanel: (panel: 'spaceSelection' | 'textManipulation') => void;
  closePanel: () => void;
  setMenuOpen: (open: boolean) => void;
  toggleMenu: () => void;
}

export const useSpaceToolsStore = create<SpaceToolsState>((set) => ({
  activePanel: 'none',
  menuOpen: false,

  setActivePanel: (panel) => set({ activePanel: panel, menuOpen: false }),

  togglePanel: (panel) => set((state) => ({
    activePanel: state.activePanel === panel ? 'none' : panel,
    menuOpen: false,
  })),

  closePanel: () => set({ activePanel: 'none' }),

  setMenuOpen: (open) => set({ menuOpen: open }),

  toggleMenu: () => set((state) => ({ menuOpen: !state.menuOpen })),
}));
